<template>
    <div class="favourites-container">
        <v-layout column wrap fill-height>
            <div class="loading-screen" v-if="isLoading">
                <v-img class="loading-gif" src="../assets/loading.gif"></v-img>
            </div>

            <div class="trading-desk-container1">
                <div class="wine-market-wrapper" v-if="mobileCheck">
                    <div class="mobile-wines-body" v-if="favWinesListLength">
                        <div class="mobile-wines-row" v-for="(item, index) in favWinesList" :key="index">
                            <div>
                                <div v-on:click="() => { goToWineDetails(item) }" class="wine-vintage-name">
                                    {{ item.displayWineName }}
                                </div>
                                <h3 v-if="item.wineName && item.isSecondLabel" class="addition-description">2-nd label of {{ item.producerTypeName ? `${item.producerTypeName} ${item.producerName}` : item.producerName }}</h3>
                                <h3 v-if="item.wineName && item.isSecondLabel" class="addition-description">{{ item.producerTypeName ? `${item.producerTypeName} ${item.producerName}` : item.producerName }}</h3>
                            </div>
                            <div v-if="item.isEnPrimeur" class="wine-enprimeur-mobile">
                                En Primeur
                                <div class="info-text">{{ $t('will-be-bottled') }}{{item.vintage.charAt(2)}}{{parseInt(item.vintage.charAt(3)) + 3}}</div>
                            </div>
                            <div class="second-row">
                                <div class="mobile-wines-div wineitem-td region-td">
                                    <div class="country-flag"
                                         :style="{ background: `url(${item.countryFlagUrl}) no-repeat center` }"></div>
                                    {{ item.countryName }}, {{ item.regionName }}, {{ item.appellation }}
                                </div>
                                <div class="mobile-wines-div wineitem-td">
                                    <div class="winemarket-winecolor-img winemarket-winecolor-img-m"
                                         :class="item.colorId == 1 ? 'redwine' : (item.colorId == 2 ? 'whitewine' : 'champagne')"></div>
                                    <div class="winecolor-tooltip">
                                        {{
                                            item.colorId == 1 ? $t('red') : (item.colorId == 2 ? $t('white') : (item.colorId == 3 ? $t('rose') : $t('champagne')))
                                        }}
                                    </div>
                                </div>
                            </div>
                            <div class="mobile-wines-header" v-if="favWinesListLength">
                                <div>{{ $t('case-size') }}</div>
                                <div>{{ $t('best-sell') }}</div>
                                <div>{{ $t('best-buy') }}</div>
                                <div>{{ $t('last-trade') }}</div>
                                <div>{{ $t('favourites') }}</div>
                            </div>
                            <div class="mobile-wines-body" v-if="favWinesListLength">
                                <div class="content">
                                    <div>
                                        {{ item.size }}l
                                    </div>
                                    <div class="mobile-wines-div">
                                        {{
                                            formatPrice(item.sellPrice.toLocaleString("fi-FI", {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2
                                            }).replace(',', '.'))
                                        }}
                                    </div>
                                    <div class="mobile-wines-div">
                                        {{
                                            formatPrice(item.buyPrice.toLocaleString("fi-FI", {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2
                                            }).replace(',', '.'))
                                        }}
                                    </div>
                                    <div class="mobile-wines-div wine-last-traded-price wine-last-traded-price-m">
                                        {{
                                            item.lastTradePrice == null ? '-' : formatPrice(item.lastTradePrice.toLocaleString("fi-FI", {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2
                                            }).replace(',', '.'))
                                        }}
                                        <div class="winemarket-change winemarket-change-m"
                                             :class="item.change > -1 ? 'positive' : (item.change == null ? '' : 'negative')">
                                            {{ item.change == null ? '0.00%' : `${item.change.toFixed(2)}%` }}
                                        </div>
                                    </div>
                                    <div class="mobile-wines-div favourite" style="position: relative">
                                        <button v-on:click="(event) => toggleFav(event, item)"
                                                class="wine-star wine-star-m active"></button>
                                    </div>
                                </div>
                                <div class="buttons">
                                    <button class="btn-secondary market-btn" v-on:click="() => selectWine(item, false)"
                                            :disabled="checkWineSell(item)">{{ $t('sell') }}
                                    </button>
                                    <div class="btn-secondary market-btn" v-on:click="() => selectWine(item, true)">
                                        {{ $t('buy') }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="no-fav" v-if="!favWinesListLength">
                        <div v-if="isLogged">{{ $t('no-fav-wines') }}</div>
                        <button v-if="isLogged" class="btn-primary goto-market-btn" v-on:click="goToMarket">Explore
                            wines
                        </button>
                    </div>
                </div>
                <div class="wine-market-wrapper" v-else>
                    <div v-if="favWinesListLength">
                        <v-row v-for="(favouriteItem, index) in favWinesList" :key="index" no-gutters>
                            <div class="favourite-row">
                                <div class="favourite-row-header"></div>
                                <div class="favourite-row-content">
                                    <div class="wine-details-head">
                                        <div class="portfolio-wine-bottle">
                                            <img :src="favouriteItem.bottlePicture" alt="wine bottle image"
                                                 class="portfolio-wine-bottle-img"/>
                                        </div>
                                        <div class="right-side new-portfolio-right-side">
                                            <div>
                                                <div>
                                                    <h2 v-on:click="() => goToWineDetails(favouriteItem)">{{ favouriteItem.displayWineName }}</h2>
                                                </div>
                                                <h3 v-if="favouriteItem.wineName && favouriteItem.isSecondLabel" class="addition-description">2-nd label of {{ favouriteItem.producerTypeName ? `${favouriteItem.producerTypeName} ${favouriteItem.producerName}` : favouriteItem.producerName }}</h3>
                                                <h3 v-if="favouriteItem.wineName && !favouriteItem.isSecondLabel" class="addition-description">{{ favouriteItem.producerTypeName ? `${favouriteItem.producerTypeName} ${favouriteItem.producerName}` : favouriteItem.producerName }}</h3>
                                            </div>
                                            <div class="second-row">
                                                <div v-if="favouriteItem.isEnPrimeur" class="wine-enprimeur">
                                                    En Primeur
                                                    <div class="info-text">{{ $t('will-be-bottled') }}{{favouriteItem.vintage.charAt(2)}}{{parseInt(favouriteItem.vintage.charAt(3)) + 3}}</div>
                                                </div>
                                                <div class="wine-details-region">
                                                    <div class="wine-details-img country-flag"
                                                         :style="{ background: `url(${favouriteItem.countryFlagUrl}) no-repeat center` }"></div>
                                                    <div class="country-name">{{ favouriteItem.countryCode === 'FR' ? 'France' : (favouriteItem.countryCode === 'IT' ? 'Italy' : (favouriteItem.countryCode === 'AR' ? 'Argentina' : (favouriteItem.countryCode === 'CL' ? 'Chile' : (favouriteItem.countryCode === 'ES' ? 'Spain' : 'United States')))) }}</div>
                                                    <div class="region-name">{{ favouriteItem.regionName }},
                                                        {{ favouriteItem.appellation }}
                                                    </div>
                                                    <div class="winemarket-winecolor-img"
                                                         :class="favouriteItem.colorId == 1 ? 'redwine' : (favouriteItem.colorId == 2 ? 'whitewine' : 'champagne')"></div>
                                                    <div class="last-trade-el">{{
                                                            $t(favouriteItem.colorId == 1 ? 'red' : (favouriteItem.colorId == 2 ? 'white' : (favouriteItem.colorId == 3 ? 'rose' : 'champagne')))
                                                        }}
                                                    </div>
                                                    <div class="last-trade-el last-trade-el-class">
                                                        {{ favouriteItem.classification }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <v-data-table v-if="favouriteItem.size" :headers="headers"
                                                  :items="favWinesList.filter((item, elIndex) => elIndex == index)"
                                                  hide-default-footer fixed-header
                                                  class="default-table table-two-rows myportfolio-table fav-table">
                                        <template v-slot:item="{ item }">
                                            <tr>
                                                <td class="winesize-td text-left">
                                                    {{ item.size }}l
                                                </td>
                                                <td class="winesize-td text-left">
                                                    {{
                                                        formatPrice(item.sellPrice.toLocaleString("fi-FI", {
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2
                                                        }).replace(',', '.'))
                                                    }}
                                                </td>
                                                <td class="winesize-td text-left">
                                                    {{
                                                        formatPrice(item.buyPrice.toLocaleString("fi-FI", {
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2
                                                        }).replace(',', '.'))
                                                    }}
                                                </td>
                                                <td class="winesize-td text-left">
                                                    {{
                                                        item.lastTradePrice == null ? '-' : formatPrice(item.lastTradePrice.toLocaleString("fi-FI", {
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2
                                                        }).replace(',', '.'))
                                                    }}
                                                    <div class="winemarket-change"
                                                         :class="item.change > -1 ? 'positive' : (item.change == null ? '' : 'negative')">
                                                        {{
                                                            item.change == null ? '0.00%' : `${item.change.toFixed(2)}%`
                                                        }}
                                                    </div>
                                                </td>
                                                <td>
                                                    <button v-on:click="(event) => toggleFav(event, item)"
                                                            class="wine-star active"></button>
                                                </td>
                                                <td class="market-btn-col half-padding-right">
                                                    <button class="btn-secondary market-btn"
                                                            v-on:click="() => selectWine(item, false)"
                                                            :disabled="checkWineSell(item)">{{ $t('sell') }}
                                                    </button>
                                                </td>
                                                <td class="market-btn-col half-padding-left">
                                                    <div class="btn-secondary market-btn"
                                                         v-on:click="() => selectWine(item, true)">{{
                                                            $t('buy')
                                                        }}
                                                    </div>
                                                </td>
                                            </tr>
                                        </template>
                                    </v-data-table>
                                </div>
                            </div>
                        </v-row>
                    </div>
                    <div v-else class="no-fav">
                        <div v-if="!isLogged">Join Vindome to start building your collection of favourite wines</div>
                        <div v-if="isLogged">{{ $t('no-fav-wines') }}</div>
                        <button v-if="isLogged" class="btn-primary goto-market-btn" v-on:click="goToMarket">Explore
                            wines
                        </button>
                        <button v-if="!isLogged" class="btn-primary goto-market-btn" v-on:click="goToLogin">Join
                            Vindome
                        </button>
                    </div>
                </div>
            </div>
        </v-layout>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';
import {APortfolio, AUser, AWines} from "@/store/actions";
import {GPortfolio, GWines} from "@/store/getters";
import moment from "moment";
import {GCommon} from "@/store/getters";

export default {
    name: "Favourites",
    head: {
        title: 'Favourites | Fine Wine Trading App',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Buy and sell fine wines from your smartphone today! Vindome is the fast, secure and easy way to become a wine trader – right from your smartphone.'
            }
        ],
    },
    data() {
        return {
            isLoading: true,
            isLogged: false
        }
    },
    computed: {
        ...mapGetters({
            favWinesList: GWines.GET_FAVOURITE_WINES,
            favWinesListLength: GWines.GET_FAVOURITE_WINES_LENGTH,
            portfolioSummary: GPortfolio.GET_PORTFOLIO_SUMMARY,
            mobileCheck: GCommon.GET_MOBILE_VERSION
        }),
        headers() {
            return [
                {text: this.$i18n.t('case-size'), align: 'left', value: 'size'},
                {text: this.$i18n.t('best-sell'), align: 'left', value: 'units'},
                {text: this.$i18n.t('best-buy'), align: 'left', value: 'price'},
                {text: this.$i18n.t('last-trade'), align: 'left', value: 'lastTradePrice'},
                {text: this.$i18n.t('favourites'), align: 'left', value: 'isFavourite'},
                {text: '', value: 'buyWine'},
                {text: '', value: 'sellWine'}
            ]
        }
    },
    methods: {
        formatPrice(price) {
            return `€ ${price}`
        },
        goToWineDetails(item) {
            this.wineId = item.wineId;
            this.$store.dispatch(AWines.SELECT_WINE_ID, {
                wineId: item.wineId,
                caseSize: item.caseSizeId,
                languageId: this.$i18n.locale
            });
            this.$store.dispatch(AWines.GET_WINE_DETAILS).then(() => {
                this.$router.push(this.localePath({path: '/wine-details/' + item.wineId + '/' + item.caseSizeId + '/' + item.appellation.toLowerCase().split(' ').join('-') + '-' + (item.classification ? item.classification.toLowerCase().split(' ').join('-') : '') + '-' + (item.colorId === 1 ? 'red' : (item.colorId === 2 ? 'white' : (item.colorId === 3 ? 'rose' : 'champagne'))) + '-' + item.vintage + '-' + item.producerName.toLowerCase().split(' ').join('-') + '-' + (item.producerTypeName ? item.producerTypeName.toLowerCase().split(' ').join('-') : '')}));
            })
        },
        goToMarket() {
            this.$router.push(this.localePath({path: '/trading-desk'}));
        },
        goToLogin() {
            this.$router.push(this.localePath({path: '/login'}));
        },
        selectWine(item, isBuy) {
            this.wineId = item.wineId;
            this.$store.dispatch(AWines.SELECT_WINE_ID, {
                wineId: item.wineId,
                caseSize: item.caseSizeId,
                languageId: this.$i18n.locale
            });
            this.$store.dispatch(AWines.GET_WINE_DETAILS);
            this.$router.push(this.localePath({path: (isBuy ? '/wine-trading-buy/' : '/wine-trading-sell/') + item.wineId}));
        },
        toggleFav(event, wine) {
            event.stopPropagation();

            this.$store.dispatch(AWines.SWITCH_WINE_FAVOURITE, {wineId: wine}).then(() => {
                this.$store.dispatch(AWines.GET_FAVOURITE_WINES)
            });
        },
        formatDate(date, format) {
            return moment(date).locale(this.$i18n.locale).format(format == null ? 'DD-MM-YYYY HH:mm' : format)
        },
        checkWineSell(wineObj) {
            let isSellAvailable = true;

            if (this.portfolioSummary && this.portfolioSummary.length) {
                this.portfolioSummary.forEach(wine => {
                    if (wine.wineId === wineObj.wineId && wine.caseSizeId === wineObj.caseSizeId) {
                        isSellAvailable = false;
                        return false;
                    }
                });
            }

            return isSellAvailable
        }
    },
    created() {
        this.$store.dispatch(AUser.GET_USER_DATA).then(() => {
            this.isLogged = true;
            this.$store.dispatch(APortfolio.GET_PORTFOLIO_SUMMARY);
            this.$store.dispatch(AUser.GET_USER_COMMISSION);

            this.$store.dispatch(AWines.GET_FAVOURITE_WINES)
        }).catch((err) => {
            this.isLogged = false;
        });
    },
    watch: {
        favWinesListLength: {
            immediate: true,
            deep: true,
            handler(v) {
                this.isLoading = false
            }
        }
    }
}
</script>

<style>
.wine-market-wrapper .theme--light.v-data-table.v-data-table--fixed-header.default-table thead th {
    padding-bottom: 0;
}
.info-text {
    background: #303030;
    border-radius: 6px;
    padding: 6px;
    color: #ffffff;
    text-align: center;
    width: 160px;
    font-size: 14px;
    position: absolute;
    right: -45px;
    height: 45px;
    margin-top: -71px;
    white-space: pre-line;
    display: none;
}
.info-text:before {
    content: "";
    position: absolute;
    top: 100%;
    right: 75px;
    width: 0;
    height: 0;
    border-left: 7px solid transparent;
    border-top: 10px solid #303030;
    border-right: 7px solid transparent;
}
.wine-enprimeur:hover {
    cursor: pointer;
}
.wine-enprimeur:hover .info-text,
.wine-enprimeur-mobile:hover .info-text {
    display: block;
}
</style>

<style scoped>
.wine-details-head .addition-description,
.mobile-wines-body .mobile-wines-row .addition-description {
    font-family: Roboto, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%;
    margin-bottom: 0;
    color: var(--black);
}

.wine-details-head .addition-description {
    margin: 5px 0 7px;
}

.wine-details-head {
    display: flex;
    width: 100%;
    color: var(--black);
    padding: 0 0 16px 58px;
    position: relative;
    min-height: 50px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.portfolio-wine-bottle {
    position: absolute;
    left: 16px;
    top: 0;
    height: 66px;
    padding-bottom: 16px;
}

.portfolio-wine-bottle-img {
    background-size: contain;
    width: 14px;
    height: 50px;
}

.wine-details-head h2 {
    color: rgba(0, 0, 0, 0.88);
    font-family: Montserrat, sans-serif;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
}

.wine-details-head h2:hover {
    color: var(--blue);
    cursor: pointer;
}

.wine-details-head .second-row {
    font-weight: 300;
    line-height: 20px;
    color: var(--black);
    display: flex;
    align-items: center;
    margin-top: 3px;
}

.wine-details-head .left-side {
    margin-right: 10px;
    display: none;
}

.wine-details-head .left-side .image {
    width: 43px;
    height: 43px;
    border: 1px solid red;
}

.wine-details-head .right-side {
    flex: 1;
}

.wine-market-wrapper .default-table {
    width: 100%;
}

.wine-market-wrapper .favourite-row {
    margin-top: 30px;
    width: 100%;
}

.wine-market-wrapper .favourite-row:first-child {
    margin-top: 0;
}

.wine-market-wrapper .favourite-row .favourite-row-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.6rem;
}

.wine-market-wrapper .favourite-row .favourite-row-content {
    background-color: #FFF;
    border-radius: 8px;
    padding: 16px;
}

.wine-market-wrapper .wine-details-img {
    width: 24px;
    height: 14px;
    position: relative;
    top: 1px;
    margin-right: 8px;
    background-size: contain !important;
}

.wine-market-wrapper .region-name {
    margin-left: 32px;
}

.wine-market-wrapper .winemarket-winecolor-img {
    display: inline-block;
    width: 9px;
    height: 16px;
    position: relative;
    margin: 0 8px 0 32px;
    background: url('../assets/rose.png') no-repeat center right;
    background-size: contain;
}

.wine-market-wrapper .winemarket-winecolor-img.redwine {
    background: url('../assets/red.png') no-repeat center right;
    background-size: contain;
}

.wine-market-wrapper .winemarket-winecolor-img.whitewine {
    background: url('../assets/white.png') no-repeat center right;
    background-size: contain;
}

.wine-market-wrapper .wine-details-region {
    display: flex;
    font-family: Roboto, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%;
    color: var(--black);
}

.wine-market-wrapper .last-trade-el-class {
    margin: 0 calc(1.5 * var(--gutter));
}

.wine-enprimeur {
    background: #CEA94B;
    text-align: center;
    min-width: 65px;
    height: 16px;
    font-family: Roboto, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 17px;
    color: #FFFFFF;
    padding: 0 5px;
    border-radius: 2px;
    position: relative;
}

.wine-enprimeur + .wine-details-region {
    margin-left: 32px;
}

.wine-enprimeur-mobile {
    background: #CEA94B;
    text-align: center;
    width: 84px;
    height: 25px;
    font-family: Roboto, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    color: #FFFFFF;
    padding: 4px;
    margin-top: 10px;
    margin-bottom: 10px;
    position: relative;
    border-radius: 2px;
}

.home-wine-market {
    margin: 0 -15px;
}

.mobile-wines-header {
    display: flex;
    flex-wrap: wrap;
    padding: 0 10px;
    border-bottom: 1px solid #b2b2b2;
    padding-bottom: 15px;
    margin-bottom: 15px;
}

.mobile-wines-header div {
    color: #b2b2b2 !important;
    font-size: var(--fs-small);
    font-weight: 300;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    height: 20px;
    white-space: nowrap;
    flex-basis: 33.33%;
}

.mobile-wines-div {
}

.mobile-line {
    line-height: 20px;
}

h3 {
    color: #707070;
    margin-bottom: calc(2 * var(--gutter));
}

.goto-market-btn {
    margin-top: 32px;
}

.favourites-container {
    height: calc(100% - 413px);
    padding: 0 0 80px 0;
}

.trading-desk-container1 .v-card__text {
    height: 100%;
    padding-bottom: 0;
}

.trading-desk-table-tabs {
    padding: 0 15px;
    height: 100%;
}

.trading-desk-table-tabs .v-tabs-bar {
    background-color: #F9F9F9 !important;
}

.trading-desk-table-tabs .theme--light.v-tabs-items {
    height: calc(100% - 50px);
    background: #FFFFFF;
    -webkit-box-shadow: 0 2px 1px -1px rgba(0, 0, 0, .2), 0 1px 1px 0 rgba(0, 0, 0, .14), 0 1px 3px 0 rgba(0, 0, 0, .12) !important;
    box-shadow: 0 2px 1px -1px rgba(0, 0, 0, .2), 0 1px 1px 0 rgba(0, 0, 0, .14), 0 1px 3px 0 rgba(0, 0, 0, .12) !important;
}

.loading-screen {
    position: absolute;
    width: 100%;
    height: 100%;
    background: var(--semi-white);
    z-index: 10;
}

.darkmode .loading-screen {
    background: #2E313A;
}

.loading-gif {
    margin: 100px auto;
    width: 200px;
    height: 200px;
}

.favourites-table {
    height: calc(100% - 95px);
    margin: 0 40px;
    background-color: transparent;
    box-shadow: none !important;
}

.wine-market-table-header-ctrls {
    height: 75px;
    padding-top: 5px;
    background: #ffffff;
    border-bottom: 1px solid #EAEEF1;
}

.darkmode .wine-market-table-header-ctrls {
    background: #2E313B;
    border-bottom: 1px solid #484E5C;
}

.winemarket-search-filter {
    width: calc(100% - 30px);
    display: inline-block;
    border-radius: 3px;
    text-indent: 48px;
    padding-left: 25px;
    background: url('../assets/search_icon.png') no-repeat 40px 16px;
}

.wine-market-wrapper {
    height: 100%;
}

.winemarket-change {
    margin: 2px 0;
    display: inline-block;
    color: rgba(0, 0, 0, 0.88);
    font-family: Montserrat, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.winemarket-change.negative div {
    width: 10px;
    height: 15px;
    background-size: contain;
    display: inline-block;
    top: 1px;
    position: relative;
    background: url('../assets/price-low-10px.svg') no-repeat center;
}

.winemarket-change.positive div {
    width: 10px;
    height: 15px;
    background-size: contain;
    display: inline-block;
    top: 1px;
    position: relative;
    background: url('../assets/price-up-10px.svg') no-repeat center;
}

.winemarket-winecolor-img {
    height: 17px;
    position: relative;
    background: url('../assets/rose.png') no-repeat center right;
    background-size: contain;
}

.winemarket-winecolor-img.redwine {
    background: url('../assets/red.png') no-repeat center right;
    background-size: contain;
}

.winemarket-winecolor-img.whitewine {
    background: url('../assets/white.png') no-repeat center right;
    background-size: contain;
}

.winemarket-winecolor-img-m {
    margin-left: 10px;
    margin-right: 10px;
    height: 15px;
    display: inline-block;
    width: 10px;
}

.wine-last-traded-price-m {
    line-height: 20px;
    position: relative;
}

.winecolor-tooltip {
    height: 25px;
    font-size: var(--fs-small);
    font-weight: 300;
    border-radius: 5px;
    line-height: 25px;
    margin-top: 3px;
}

.wine-vintage-name {
    font-size: var(--fs-base);
    font-weight: 400;
}

.wine-vintage-name:hover {
    color: var(--brand);
    cursor: pointer;
}

.mobile-wines-div .wine-vintage-name,
.mobile-wines-div .winecolor-tooltip {
    display: inline-block;
}

.producer-info {
    color: #B2B2B2;
    font-size: var(--fs-small);
    font-weight: 300;
}

.v-data-table tr:hover,
.v-data-table td:hover {
    cursor: pointer;
}

.order-success-text {
    text-align: center;
}

.close-order-success-modal {
    margin: 0 auto;
}

.show-hide-ctrl {
    background: url('../assets/sprite-web.png') no-repeat -5px -640px;
    width: 40px;
    height: 47px;
    position: absolute;
    right: 42px;
    top: 92px;
    z-index: 9;
}

.show-hide-ctrl-options {
    position: relative;
    width: 150px;
    right: 90px;
    top: 48px;
    -webkit-box-shadow: 0 2px 1px -1px rgba(0, 0, 0, .2), 0 1px 1px 0 rgba(0, 0, 0, .14), 0 1px 3px 0 rgba(0, 0, 0, .12) !important;
    box-shadow: 0 2px 1px -1px rgba(0, 0, 0, .2), 0 1px 1px 0 rgba(0, 0, 0, .14), 0 1px 3px 0 rgba(0, 0, 0, .12) !important;
}

.show-hide-ctrl:hover {
    cursor: pointer;
    background-position-x: -41px;
}

.country-flag {
    width: 30px;
    height: 15px;
    background-size: contain !important;
    display: inline-block;
    top: 1px;
    margin-right: 5px;
    position: relative;
}

.mobile-wines-div .wine-star {
    left: 0;
    right: auto;
}

.wine-star {
    background: url('../assets/star-not-selected.svg') no-repeat center;
    width: 24px;
    height: 24px;
    display: block;
    margin: 0;
    background-size: contain;
}

.wine-star:focus,
.wine-star:active {
    outline: none;
}

.wine-star.active,
.wine-star:hover {
    background: url('../assets/star-selected.svg') no-repeat center;
    background-size: contain;
}

.wine-star.active:hover {
    opacity: 0.8;
}

.wine-star-m {
    position: absolute;
    top: 2px;
    right: 0;
}

.table-row-collapsed {
    width: 11px;
    height: 7px;
    background: url('../assets/sprite-web.png') no-repeat -74px -712px;
}

.table-row-expanded {
    width: 11px;
    height: 7px;
    background: url('../assets/sprite-web.png') no-repeat -74px -725px;
}

.trading-desk-container2 {
    height: 300px;
}

.market-btn-col {
    width: 100px;
}

.half-padding-left {
    padding-left: calc(0.5 * var(--gutter));
}

.no-padding-right {
    padding-right: 0;
}

.half-padding-right {
    padding-right: calc(0.5 * var(--gutter));
}

.market-btn,
.filter-btn {
    width: 125px;
    font-weight: 300;
    text-align: center;
    line-height: 1em;
    height: 32px;
}

.market-btn:hover {
    background-color: var(--blue);
    border-color: var(--blue);
}

.mobile-wines-div .market-btn {
    width: 100%;
}

.bids-offers-modal h3 {
    margin-bottom: 16px;
    font-size: var(--fs-large);
}

.btn-bid-proceed {
    font-size: var(--fs-base);
    text-transform: initial;
    font-weight: 300;
    padding: 0 20px !important;
    background: var(--brand);
    color: #ffffff;
}

.btn-bid-cancel {
    font-size: var(--fs-base);
    text-transform: initial;
    font-weight: 300;
    padding: 0 20px !important;
}

.btn-bid-cancel:hover {
    color: #ffffff;
}

.bids-offers-modal {
    padding: 32px 48px;
    text-align: center;
    background: #f6f6f6;
}

.bids-offers-modal .warning-icon {
    background: url('../assets/report_problem-24px.svg') no-repeat center;
    background-size: contain;
    width: 40px;
    height: 40px;
    margin: 0 auto;
}

.bids-title svg {
    margin-right: 5px;
    fill: #707070;
}

.offers-title svg {
    margin-right: 5px;
    fill: #707070;
}

.cancel-bid-body {
    text-align: center;
    justify-content: center;
    font-size: var(--fs-base);
}

.mobile-wines-body .mobile-wines-row {
    margin-top: 30px;
}

.mobile-wines-body .mobile-wines-row .addition-description {
    font-size: 14px;
}

.mobile-wines-body .mobile-wines-row:first-child {
    margin-top: 0;
}

.mobile-wines-row .second-row {
    display: flex;
    margin: var(--gutter) 0 calc(2 * var(--gutter));
    color: var(--black);
}

.mobile-wines-row .content {
    display: flex;
    flex-wrap: wrap;
}

.mobile-wines-row .buttons {
    display: flex;
}

.mobile-wines-row .buttons button,
.mobile-wines-row .buttons div {
    flex: 1;
}

.mobile-wines-row .buttons button {
    margin-right: 10px;
}

.mobile-wines-row .buttons button + div {
    margin-left: 10px;
}

.mobile-wines-row .content div {
    flex-basis: 33.33%;
}

.mobile-wines-div.wineitem-td,
.mobile-wines-div.region-td {
    flex: 1;
}

.mobile-wines-div.market-btn-col {
    width: 50%;
}

.best-buy2 {
    padding-left: 10px;
}

@media (max-width: 767px) {
    .favourites-container {
        padding: 30px 0;
    }

    .wine-vintage-name {
        font-family: var(--heading-font);
        font-size: 20px;
        font-weight: 600;
        line-height: 22px;
        color: var(--black)
    }
}

.theme--light.v-data-table.default-table.table-two-rows tbody tr td {
    height: 35px;
}
</style>

<style>
.bids-offers-modal .v-card__title,
.bids-offers-modal .v-card__actions {
    justify-content: center;
}

html {
    overflow-y: auto;
}

.trading-desk .vindome-container {
    background: #f7f8f9;
    padding: 0;
}

.show-hide-ctrl-options .accent--text {
    color: #024e7b !important;
    caret-color: #024e7b !important;
}

.theme--light.v-data-table thead tr th {
    font-weight: 500;
    font-size: 14px;
    color: #303344;
    letter-spacing: +0.28px;
}

.winemarket-search-filter .v-input__slot:before,
.winemarket-wine-filter .v-input__slot:before {
    border: 0 !important;
}

.winemarket-search-filter.v-input input {
    max-height: 36px;
    text-indent: 47px;
}

.winemarket-wine-filter.v-input input {
    max-height: 36px;
}

.winemarket-search-filter .theme--light.v-label {
    color: #000;
}

.darkmode .winemarket-search-filter .theme--light.v-label {
    color: #838489;
}

.winemarket-wine-filter .v-input__icon {
    padding-right: 15px;
}

.favourites-table.v-data-table--fixed-header .v-data-table__wrapper {
    height: 100%;
}

.favourites-table.v-data-table--fixed-header .v-data-table__wrapper::-webkit-scrollbar {
    width: 10px;
    background-color: var(--semi-white);
    display: none;
}

.darkmode .favourites-table.v-data-table--fixed-header .v-data-table__wrapper::-webkit-scrollbar {
    background-color: #232429;
}

.favourites-table.v-data-table--fixed-header:hover .v-data-table__wrapper::-webkit-scrollbar {
    display: block;
}

.favourites-table.v-data-table--fixed-header .v-data-table__wrapper::-webkit-scrollbar-track {
    border-radius: 10px;
    background: rgba(0, 0, 0, 0.1);
    border: 1px solid #ccc;
    z-index: 10;
    height: 200px;
}

.darkmode .favourites-table.v-data-table--fixed-header .v-data-table__wrapper::-webkit-scrollbar-track {
    border: 1px solid #232429;
}

.favourites-table.v-data-table--fixed-header .v-data-table__wrapper::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: linear-gradient(to left, #fff, #e4e4e4);
    border: 1px solid #aaa;
}

.favourites-table.v-data-table--fixed-header .v-data-table__wrapper::-webkit-scrollbar-thumb:hover {
    background: #fff;
}

.favourites-table.v-data-table--fixed-header .v-data-table__wrapper::-webkit-scrollbar-thumb:active {
    background: linear-gradient(to left, #22ADD4, #1E98BA);
}

.darkmode .favourites-table.v-data-table--fixed-header .v-data-table__wrapper::-webkit-scrollbar-thumb {
    background: #838489;
    border: 1px solid #838489;
}

.darkmode .favourites-table.v-data-table--fixed-header .v-data-table__wrapper::-webkit-scrollbar-thumb:hover {
    background: #fff;
}

.darkmode .favourites-table.v-data-table--fixed-header .v-data-table__wrapper::-webkit-scrollbar-thumb:active {
    background: #E5C57B;
}


.show-hide-ctrl-options .v-list-item--link {
    min-height: 28px;
}

.show-hide-ctrl-options .v-list-item__content {
    padding: 0;
}

.show-hide-ctrl-options .v-input--selection-controls,
.show-hide-ctrl-options .v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
    margin: 0;
    padding: 0;
}

.show-hide-ctrl-options .v-input--selection-controls .v-messages {
    display: none;
}

.v-data-table td.wineitem-td {
    width: 350px;
    color: #000000 !important;
}

.theme--light.v-data-table.v-data-table--fixed-header.favourites-table thead th {
    color: #A9B9C6 !important;
    background: #f7f8f9;
    box-shadow: none !important;
    height: 70px;
    padding-top: 20px;
}

.theme--light.v-data-table.favourites-table tbody tr {
    border: 0;
    background: #ffffff;
    height: 86px;
    margin-bottom: 5px;
    border-radius: 5px;
}

.theme--light.v-data-table.favourites-table tbody tr td {
    border-bottom: 5px solid #f7f8f9;
}

.darkmode .v-data-table td.wineitem-td {
    color: #ffffff !important;
}

.darkmode .theme--light.v-data-table.v-data-table--fixed-header.favourites-table thead th {
    color: #838489 !important;
    background: #2E313B;
}

.darkmode .theme--light.v-data-table.favourites-table tbody tr {
    background: #363945;
}

.darkmode .theme--light.v-data-table.favourites-table tbody tr td {
    border-bottom: 5px solid #2E313B;
    color: #ffffff;
}

.darkmode .v-data-table td.winesize-td {
    color: #838489 !important;
}

.darkmode .theme--light.v-data-table.favourites-table tbody tr td.winemarket-change.positive {
    color: #3BC34F;
}

.darkmode .theme--light.v-data-table.favourites-table tbody tr td.winemarket-change.negative {
    color: #da443d;
}

.darkmode .theme--light.v-data-table.favourites-table tbody tr td.blue-text {
    color: #E5C57B;
}

.darkmode .theme--light.v-data-table.favourites-table tbody tr:hover {
    background: #5e5f67;
}

.theme--light.v-data-table.v-data-table--fixed-header.default-table.myportfolio-table.fav-table thead tr th {
    color: rgba(0, 0, 0, 0.64) !important;
    font-family: Montserrat, sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    height: 30px;
    padding-top: 8px;
    padding-bottom: 8px;
}

.theme--light.v-data-table.v-data-table--fixed-header.default-table.myportfolio-table.fav-table tbody tr td {
    color: rgba(0, 0, 0, 0.88);
    font-family: Montserrat, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 600 !important;
    line-height: normal;
    height: 17px;
}
</style>
